import React, {useEffect, useState} from 'react';

const useIsMobilePlatform = () => {
    const [isMobile, setIsMobile ] = useState(false);
    useEffect(() => {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            setIsMobile(true)
        }

    }, [window.screen.width]);
    return isMobile
}

export default useIsMobilePlatform